import { Box, Drawer, FormControl, Grid } from "@mui/material";
import { IStoreInfoDropDown } from "./IStoreInfoDropDown";
import { useState } from "react";
import { add } from "lodash";
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import CustomisedButton from "../../button/button";

export function StoreInfoDropDown({ element, address, lat, lng, logo, phones, title, storeTitle }: IStoreInfoDropDown) {


    const [open, setOpen] = useState(false);



    const handleOpen = () => {
        setOpen(true)
    }
    const isMobile = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);

    const mapsUrl = isMobile ? `geo:${lat},${lng}?q=${lat},${lng}(${encodeURIComponent(storeTitle + " " + title)})` :
        `https://www.google.com/maps?q=${lat},${lng}&q=${encodeURIComponent(storeTitle + " " + title)}`;

    return (
        <>
            <div>
                <FormControl fullWidth>

                    <div onClick={handleOpen}>
                        {element}
                    </div>
                </FormControl>
                <Drawer
                    anchor={'bottom'}
                    open={open}
                    sx={{ zIndex: 1221 }}
                    onClose={() => setOpen(false)}
                    PaperProps={{
                        sx: {
                            backgroundColor: 'var(--input-bg-color)',

                        }
                    }}

                >
                    <Grid
                        container
                        spacing={2}
                        textAlign={'right'}
                        fontSize={'14px'}
                        style={{ paddingRight: "0px", paddingTop: "25px", justifyContent: "start", paddingBottom: "10px", direction: "rtl", marginLeft: "0px !important", paddingLeft: "0px !important" }}
                        className="primaryColorLight-900  dropTitle  px-5 py-5 pt-8"
                        onClick={() => setOpen(false)}
                    >

                        <Grid container item spacing={0} xs={12}>

                            <div
                                style={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                    marginRight: '20px',
                                    width: "40px", height: "40px",
                                    borderRadius: "50%",
                                    background: "#fff", boxShadow: "0px 2px 4px rgba(0,0,0,0.4)",
                                    right: "20px",
                                    alignContent: "center",
                                    flexWrap: "wrap"
                                }}
                            >

                                {logo}

                            </div>
                            <div style={{ display: 'inline-block', marginRight: '15px', alignSelf: "center" }}>

                                <span style={{ fontSize: "14px", color: "var(--primary-text-color)" }} className={"text-sm "}>{title}</span>


                            </div>


                        </Grid>
                        <hr style={{ width: "100%", marginTop: "10px", marginLeft: "15px", marginRight: "15px   " }} />
                        <Grid container item spacing={0} xs={12}>

                            <div
                                style={{
                                    display: 'inline-block',
                                    marginRight: '30px',
                                    alignSelf: 'center',

                                }}
                            >
                                <LocationOnOutlinedIcon sx={{ color: 'var(--tirnary-text-color)', width: "24px", height: "24px" }} />
                                <span style={{ fontSize: "12.5px", paddingRight: "5px" }} className={"text-sm text-[var(--tirnary-text-color)]"}>{address}</span>
                            </div>
                        </Grid>

                        <Grid container item spacing={0} xs={12}>


                            <Grid style={{
                                // display: 'inline-block',
                                paddingRight: '30px',
                                paddingTop: "10px",
                                width: "100%"
                            }} item xs={2}>
                                <LocalPhoneIcon sx={{ color: 'var(--tirnary-text-color)', width: "24px", height: "24px" }} />
                            </Grid>

                            <Grid container item xs={10} style={{ paddingRight: "15px" }}>
                                {phones.map((item: string, index: number) => {
                                    return (
                                        <Grid item xs={6} style={{ marginTop: "10px", color: "#BBA57A", }} >
                                            <a href={`tel:${item}`} style={{ textDecoration: 'none', fontSize: ".85rem" }} key={item}>
                                                {item}
                                            </a>
                                        </Grid>

                                    )
                                })}
                            </Grid>

                        </Grid>
                        <Grid item xs={12} style={{ paddingBottom: "20px", paddingLeft: "20px", paddingRight: "20px" }} >
                            <a
                                className="bg-[var(--button-color)]"

                                style={{ fontSize: "0.85rem", textDecoration: "none", border: "1px solid var(--border-color)", display: "block", width: "100%", textAlign: 'center', height: "42px", borderRadius: "5px", color: "var(--semilar-color)", fontWeight: "bold", fontSizeAdjust: "15px", alignContent: "center" }} href={mapsUrl} rel="noopener noreferrer">
                                مسیریابی روی نقشه
                            </a>

                        </Grid>
                    </Grid>



                </Drawer>
            </div >
        </>
    )
}